// 🚨 This file has not been broken down into lazy-loaded, JIT files. It is low priority to do so as this is not a part of the the critical user ecommerce path.
window.cpap.onDocumentReady(() => {
  window.scheduler.postTask(
    () => {
      window.cpap = window.cpap || {};
      window.cpap.quiz = window.cpap.quiz || {};
      window.cpap.quiz.quizProductClickHandler = async (
        button,
        productId,
        productPrice,
        prescription
      ) => {
        const $button = button;

        const atcData = {
          items: [{ id: productId, quantity: 1, properties: { _Prescription: prescription } }],
        };

        $button.innerHTML = 'Adding to cart...';
        $button.disabled = true;

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(atcData),
          });

          if (!response.ok) {
            throw new Error('Network response was not ok');
          }

          $button.style.opacity = '0.5';
          setTimeout(() => {
            $button.innerHTML = 'Added to cart';
            $button.style.opacity = '1';
            $button.classList.remove('btn-primary');
            $button.classList.add(
              'cpap__theme__button--primary-filled',
              'cpap__theme__button--primary-filled--soft-fill',
              'text-center'
            );
            $button.closest('.tabbing-content').classList.add('product-added');
            document.querySelector('.cart-count-bubble-dot').classList.remove('hidden');
          }, 300);
        } catch (error) {
          $button.innerHTML = 'Failed to add to cart';
          $button.style.backgroundColor = '#CD3824';
          window.cpap.logError(new Error(error.message), {
            sentry__additionalData: {
              'Attempted Action': 'Add to cart',
              Component: 'quiz',
            },
            ga__errorMessagePrefix: 'Error adding product to cart: ',
          });
          setTimeout(() => {
            $button.innerHTML = `
        <span class="btn-text cpap-sm-p">Add to Cart</span>
        <span class="btn-price cpap-sm-p cpap-font-medium">${productPrice}</span>
      `;
            $button.classList.remove(
              'cpap__theme__button--primary-filled',
              'cpap__theme__button--primary-filled--soft-fill'
            );
            $button.classList.add('btn-primary');
            $button.style.backgroundColor = '';
          }, 3000);
        }
      };

      const loadDeferredUtilityFunctions = (callback) => {
        window.cpap.dynamicallyLoadScript(
          window.cpap.cdnSources.cpapJitUtilitiesJs,
          callback ? { onload: callback } : undefined
        );
      };

      // Preload the JIT utility functions
      window.scheduler.postTask(() => loadDeferredUtilityFunctions(), { priority: 'background' });

      document.querySelector('.quiz-steps').addEventListener('change', (event) => {
        const selectElement = event.target.closest('select');

        if (!selectElement) return;

        const errorTipsElement = selectElement
          .closest('.product-option')
          ?.querySelector('.error-tips');
        if (errorTipsElement) {
          errorTipsElement.classList.remove('is-show');
        }

        // Add click state
        selectElement.closest('.product-option')?.classList?.add('is-click');

        // Get all select elements in the current card
        const cardBottom = selectElement.closest('.cpap__product-comparisons__card-bottom');
        const selectElements = cardBottom?.querySelectorAll('select');

        // Extract select names and values
        const selectData = Array.from(selectElements).reduce((acc, select, index) => {
          const name = select.getAttribute('name');
          const value = select.value;

          acc[`select_name_${index + 1}`] = name || '';
          acc[`select_val_${index + 1}`] = value || '';

          return acc;
        }, {});

        // Find matching variant
        let isVariantFound;
        let dataSize = '';
        let dataColor = '';
        let data3 = '';
        let dataId = '';
        let dataSoldOut = '';
        let dataPrescription = '';
        let dataPrice = '';

        // Get the reference data including stock information from Shopify as saved in html variables.
        const varsValueElements = cardBottom?.querySelectorAll('.vars-value div') || [];

        for (let i = 0; i < varsValueElements.length; i++) {
          isVariantFound = false;
          const varElement = varsValueElements[i];
          dataSize = varElement.getAttribute(`data-${selectData.select_name_1}`) || '';
          dataColor = selectData.select_name_2
            ? varElement.getAttribute(`data-${selectData.select_name_2}`) || ''
            : '';
          data3 = selectData.select_name_3
            ? varElement.getAttribute(`data-${selectData.select_name_3}`) || ''
            : '';

          dataId = varElement.getAttribute('data-id');
          dataSoldOut = varElement.getAttribute('data-soldout');
          dataPrescription = varElement.getAttribute('data-prescription');

          dataPrice = parseFloat(varElement.getAttribute('data-price')) / 100;
          dataPrice = dataPrice.toFixed(2);

          const selectValues = [
            selectData.select_val_1,
            selectData.select_val_2,
            selectData.select_val_3,
          ];
          const hasSelectedValues = selectValues.some((value) => value && value !== 'defaultTitle');

          // Check if variant matches selected options
          isVariantFound =
            hasSelectedValues &&
            (!selectData.select_val_1 || dataSize === selectData.select_val_1) &&
            (!selectData.select_val_2 || dataColor === selectData.select_val_2) &&
            (!selectData.select_val_3 || data3 === selectData.select_val_3);

          if (isVariantFound) {
            break;
          }
        }

        const addToCartButton = event.target.closest(
          '.cpap__product-comparisons__add-to-cart-button'
        );
        const primaryButton = addToCartButton.querySelector('.btn-primary');
        const btnTextElement = addToCartButton.querySelector('.btn-text');
        const btnPriceElement = addToCartButton.querySelector('.btn-price');

        const setOutOfStock = () => {
          setTimeout(() => {
            if (primaryButton) {
              primaryButton.disabled = true;
              btnTextElement.textContent = 'Out of Stock';
            }
          }, 400);
        };
        const setAddToCart = () => {
          setTimeout(() => {
            if (primaryButton) {
              primaryButton.disabled = false;
              btnTextElement.textContent = 'Add to Cart';
              btnPriceElement.textContent = `$${dataPrice}`;

              primaryButton.setAttribute(
                'onclick',
                `window.cpap.quiz.quizProductClickHandler(this, ${dataId}, '$${dataPrice}', '${dataPrescription}')`
              );
            }
          }, 400);
        };

        // Set add to cart/out of stock options. If no match is found, then keep "select options" UI.
        if (isVariantFound === true) {
          if (dataSoldOut === 'false') {
            setAddToCart();
          } else {
            setOutOfStock();
          }
        } else {
          setOutOfStock();
        }
      });

      function addCartButtons() {
        // Check and remove existing buttons if they already exist
        const existingViewCartButton = document.getElementById('view-cart');

        if (existingViewCartButton) {
          existingViewCartButton.remove();
        }

        const existingViewCheckoutButton = document.getElementById('view-checkout');

        if (existingViewCheckoutButton) {
          existingViewCheckoutButton.remove();
        }

        const viewCartButton = document.createElement('a');

        viewCartButton.id = 'view-cart';
        viewCartButton.className = 'cpap__theme__button--white';
        viewCartButton.textContent = 'View Cart';
        viewCartButton.href = '/cart';

        const viewCheckoutButton = document.createElement('a');
        viewCheckoutButton.id = 'view-checkout';
        viewCheckoutButton.className = 'cpap__theme__button--white';
        viewCheckoutButton.textContent = 'Proceed to Checkout';
        viewCheckoutButton.href = '/checkout';

        document.querySelector('.tabbing-nav').append(viewCartButton);
        document.querySelector('.tabbing-nav').append(viewCheckoutButton);
      }

      let top3Rendered = false;
      let klaviyoSubscribed = false;

      // Handle subscription to the mailing list. Where/how is this getting used?
      function klaviyoSubscribeUser() {
        // Adding logging to determine if this is ever used
        window.cpap.pushDataLayer({
          event: 'log',
          interaction_type: 'log',
          is_user_interaction: 'true',
          severity: 'info',
          message_text: 'The global klaviyoSubscribeUser() function was called',
        });

        function formatPhoneNumber(phoneNumber) {
          phoneNumber = phoneNumber.replace(/[^+\d]/g, '');

          // Ensure the phone number starts with a '+'
          if (!phoneNumber.startsWith('+')) {
            phoneNumber = `+${phoneNumber}`;
          }

          // Validate the phone number length and structure for E.164 format
          const e164Pattern = /^\+\d{1,15}$/;
          if (phoneNumber.length > 1 && !e164Pattern.test(phoneNumber)) {
            alert('Invalid phone number format. It should be in E.164 format.');
            throw new Error('Invalid phone number format');
          }

          return phoneNumber;
        }

        const firstName = document.getElementById('first-name').value;
        const lastName = document.getElementById('last-name').value;
        const email = document.getElementById('email').value;
        const phoneNumber = formatPhoneNumber(document.getElementById('phone-number').value);
        const emailSubscribed = document.getElementById('email-news-offers').checked;
        const smsSubscribed = document.getElementById('text-news-offers').checked;

        const profileAttributes = {
          anonymous_id: '01GDDKASAP8TKDDA2GRZDSVP4H',
          first_name: firstName,
          last_name: lastName,
        };

        if (emailSubscribed) {
          profileAttributes.email = email;
        }
        if (smsSubscribed) {
          profileAttributes.phone_number = phoneNumber;
        }

        const options = {
          method: 'POST',
          headers: { revision: '2024-07-15', 'content-type': 'application/json' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Homepage footer signup form',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email,
                      phone_number: phoneNumber,
                      anonymous_id: '01GDDKASAP8TKDDA2GRZDSVP4H',
                      first_name: firstName,
                      last_name: lastName,
                    },
                  },
                },
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id: 'SVqBLM',
                  },
                },
              },
            },
          }),
        };

        function disableInputs() {
          document.getElementById('first-name').disabled = true;
          document.getElementById('last-name').disabled = true;
          document.getElementById('email').disabled = true;
          document.getElementById('phone-number').disabled = true;
          document.getElementById('email-news-offers').disabled = true;
          document.getElementById('text-news-offers').disabled = true;
        }

        if (emailSubscribed || smsSubscribed) {
          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=UnFfF4', options)
            .then((response) => {
              if (response.ok) {
                disableInputs();
                klaviyoSubscribed = true;
                document.getElementById('klaviyo-subscribe-form').style.opacity = '0.5';
                return response.json();
              } else {
                throw new Error('Network response was not ok');
              }
            })
            .catch((error) => {
              window.cpap.logError(error, {
                sentry__additionalData: {
                  'Attempted Action': 'Subscribing to marketing email',
                },
                ga__errorMessagePrefix: 'Error subscribing to marketing email: ',
              });
            });
        }
      }

      // Function to calculate and store top three product points from the active divs for the different product pools present in the fullProductsMetaobject
      function calculateAndStorePoints() {
        let totalPoints = {};

        document.querySelectorAll('.choose-block.active').forEach((block) => {
          let scriptContent = block.querySelector('.product-points').innerHTML.trim();
          let productPoints = JSON.parse(scriptContent);
          for (const [key, value] of Object.entries(productPoints)) {
            if (totalPoints.hasOwnProperty(key)) {
              totalPoints[key] += value;
            } else {
              totalPoints[key] = value;
            }
          }
        });

        const fullProductsMetaobject = window.cpap.quiz.fullProductsMetaobject;
        const groupedProducts = {};

        for (const product in totalPoints) {
          if (fullProductsMetaobject.hasOwnProperty(product)) {
            const productData = fullProductsMetaobject[product];
            if (productData?.id) {
              const division = productData.merchant_division;
              if (!groupedProducts.hasOwnProperty(division)) {
                groupedProducts[division] = [];
              }
              groupedProducts[division].push({
                product: product,
                points: totalPoints[product],
                metadata: productData,
              });
            }
          }
        }

        const topProductsByDivision = {};

        for (const division in groupedProducts) {
          const sortedProducts = groupedProducts[division].sort((a, b) => a.points - b.points);
          topProductsByDivision[division] = sortedProducts.slice(-3).map((item) => item.metadata);
        }
        return topProductsByDivision;
      }

      document.getElementById('subscription-submission').addEventListener('click', (event) => {
        event.preventDefault();

        // Calculate and store points
        let topProductsByDivision = calculateAndStorePoints();

        function renderTop3Tabs() {
          const firstResultsTab = document.querySelector('.tabbing-content[data-type="result"]');
          let loopCount = 0;

          for (const division in topProductsByDivision) {
            loopCount++;

            let categoryToRender = division.endsWith('s') ? division.slice(0, -1) : division;

            const tabbingContentHtml = `
              <div class="cpap__product-comparisons-quiz-results your-result z-1">
                  <h3>Select Your <span>${categoryToRender}</span></h3>
                  <div class="cpap__product-comparisons p-0">
                      <div class="cpap__product-comparisons__product-list">
                          <div class="cpap__product-comparisons__product-card cpap__product-comparisons__quiz-results-list d-flex">
                              ${topProductsByDivision[division]
                                .map((product, productIndex) => {
                                  let label = '';
                                  let boxClass = '';
                                  let borderClass = '';
                                  let buttonText = '';
                                  let classHidden = '';

                                  if (productIndex === 0) {
                                    label = 'Good';
                                    boxClass = 'cpap__product-comparisons__card';
                                  } else if (productIndex === 1) {
                                    label = 'Better';
                                    boxClass = 'cpap__product-comparisons__card';
                                  } else {
                                    label = 'Best';
                                    boxClass =
                                      'cpap__product-comparisons__card cpap__product-comparisons__card--highlight';
                                    borderClass = 'cpap-border-0';
                                  }

                                  if (product.availability === 'true') {
                                    if (Object.keys(product.variants).length === 0) {
                                      buttonText = 'Add to Cart';
                                      classHidden = ' hidden';
                                    } else {
                                      buttonText = 'Select Options';
                                      classHidden = '';
                                    }
                                  } else {
                                    buttonText = 'Out of Stock';
                                  }

                                  return `
                                      <div
                                        class="cpap__product-comparisons-quiz-results__container col-8 col-md-4 h-100"
                                        data-dl-event="view_item_list,select_item"
                                        data-dl-item-product-id="${product.parent_id}"
                                        data-dl-item-id="${product.sku}"
                                        data-dl-item-variant-id="${product.id}"
                                        data-dl-item-name="${product.full_title}"
                                        data-dl-item-variant="${product.variant_full_title}"
                                        data-dl-item-category="${product.category}"
                                        data-dl-item-price="${product.price_float}"
                                        data-dl-item-brand="${product.vendor}"
                                        data-dl-item-compare-at-price="${
                                          product.compare_at_price_float
                                        }"
                                        data-dl-item-image="${product.featured_image}"
                                        data-dl-item-position="${productIndex + 1}"
                                        data-dl-item-list="product quiz - multiple products"
                                      >
                                          <h2 class='cpap__product-comparisons-quiz-results__ranking-label text-center cpap-lg-p'>${label}</h2>
                                          <div class="${boxClass} h-100 w-100 d-flex flex-column ${borderClass} position-relative">
                                              <a href="${product.url}" target="_blank">
                                                  <div class='cpap__product-comparisons__card-top text-center position-relative'>
                                                      <div class='cpap__product-comparisons__card-gradient'>
                                                          <figure class='m-0 mx-auto'>
                                                              <img
                                                                  src="${product.featured_image}"
                                                                  alt="${product.title}"
                                                                  srcset="
                                                                      ${
                                                                        product.featured_image
                                                                      }?width=350 350w,
                                                                      ${
                                                                        product.featured_image
                                                                      }?width=724 724w
                                                                  "
                                                                  sizes="(min-width: 1440px) 1340px, (min-width: 750px) calc(100vw - 10rem), 100vw"
                                                                  loading="eager"
                                                                  fetchpriority="high"
                                                                  width="auto"
                                                                  height="auto"
                                                                  class="object-fit-contain features-callout-body-video-img w-100 h-100"
                                                              />
                                                          </figure>
                                                          <div class='cpap__product-comparisons__reviews-container card-heading-container prescription-required'>
                                                              <h3 class='cpap-h3'>${
                                                                product.title
                                                              }</h3>
                                                              <p class='cpap-p'>${
                                                                product.tagline
                                                              }</p>
                                                              <span class="btn-learn-more cpap-font-bold cpap-sm-p position-relative p-0">Learn More</span>

                                                          </div>
                                                      </div>
                                                  </div>
                                              </a>
                                              <div class='cpap__product-comparisons__card-bottom d-flex flex-column'>
                                                  <div class='cpap__product-comparisons__product-details-list'>
                                                      <ul class='p-0'>
                                                          ${product.feature_list
                                                            .map(
                                                              (feature) => `
                                                              <li class='d-flex align-items-center cpap-font-regular cpap-sm-p'>
                                                                  <svg class="check-icon-background-false" aria-labelledby="CheckiconTitle CheckiconDesc" width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                      <title id="CheckiconTitle">Check Icon</title>
                                                                      <desc id="CheckiconDesc">This check icon represents a tick.</desc>
                                                                      <path d="M14.4857 8.16192L8.8288 13.8188L6.00059 10.9902" stroke="#394E67" stroke-linecap="round" stroke-linejoin="round"></path>
                                                                  </svg>
                                                                  ${feature}
                                                              </li>
                                                          `
                                                            )
                                                            .join('')}
                                                      </ul>
                                                  </div>
                                                  <div class="cpap__product-comparisons__add-to-cart-button mt-auto">
                                                    <div class="product-vars${classHidden}">
                                                    <div class="product-option cpap__font-icon--before">
                                                    ${product.variants
                                                      .map((category) => {
                                                        let categoryHtml = '';
                                                        for (const key in category) {
                                                          categoryHtml = `<div class="cpap__product-comparisons-quiz-results__selection-label-container">
                                                          <label>${key}</label>
                                                          <div class="error-tips">
                                                            <p>Please select a ${key
                                                              .replace(' ', '-')
                                                              .toLowerCase()}</p>
                                                          </div>
                                                        </div>`;
                                                          categoryHtml += `<select name="${key
                                                            .replace(' ', '-')
                                                            .toLowerCase()}"><option value="defaultTitle">Select ${key}</option>`;
                                                          category[key].forEach((option) => {
                                                            categoryHtml += `<option value="${option}">${option}</option>`;
                                                          });
                                                          categoryHtml += '</select>';
                                                        }
                                                        return categoryHtml;
                                                      })
                                                      .join('')}
                                                    </div>
                                                    </div>
                                                    ${product.variant_data}
                                                      <button onclick="window.cpap.quiz.quizProductClickHandler(
                                                          this,
                                                          ${product.id},
                                                          '${product.price}',
                                                          '${product.prescription}'
                                                        )"
                                                          class="btn btn-primary w-100m d-flex justify-content-between w-100 cpap-sm-p"
                                                          ${
                                                            product.availability === 'true' &&
                                                            Object.keys(product.variants).length ===
                                                              0
                                                              ? ''
                                                              : 'disabled'
                                                          }
                                                      >
                                                          <span class="btn-text cpap-sm-p">${buttonText}</span>
                                                          <span class="btn-price cpap-sm-p cpap-font-medium">${
                                                            product.availability === 'false'
                                                              ? ''
                                                              : product.price
                                                          }</span>
                                                      </button>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  `;
                                })
                                .join('')}
                          </div>
                      </div>
                  </div>
              </div>
          `;

            if (loopCount === 1) {
              firstResultsTab.insertAdjacentHTML('beforeend', tabbingContentHtml);
            } else {
              // Create the new div element for tabbing content
              const newTabbingContent = document.createElement('div');
              newTabbingContent.className = 'tabbing-content';
              newTabbingContent.setAttribute('data-type', `result${loopCount}`);
              newTabbingContent.classList.add('cpap__fadeable--hidden');
              newTabbingContent.innerHTML = tabbingContentHtml;

              // Append the new tabbing content to .tabbing-main
              document.querySelector('.tabbing-main').append(newTabbingContent);
            }

            document
              .querySelectorAll(
                '.cpap__product-comparisons-quiz-results .cpap__product-comparisons__product-card .product-vars, .cpap__product-comparisons-quiz-results .cpap__product-comparisons__product-card .btn-primary'
              )
              .forEach((element) => {
                element.addEventListener('click', function (event) {
                  event.preventDefault();
                  event.stopPropagation();
                });
              });
          }
        }

        if (!top3Rendered) {
          renderTop3Tabs();
          top3Rendered = true;
          window.cpap.pushDataLayer({
            event: 'productsRendered',
          });

          document.querySelectorAll('.product-option select').forEach((select) => {
            select.addEventListener('change', function () {
              let optionType = this.name;
              optionType = optionType
                .replace('-', ' ')
                .replace(/(?:\s)\S/g, (a) => a.toUpperCase())
                .replace(' ', '');
              let optionValue = this.value;
              let selectNames = []; // formatted name
              let optionNames = []; // unformatted name
              let options2 = [];
              let options3 = [];

              let optionTypes = this.closest('.product-option').querySelectorAll('select');
              let option1 = optionTypes[0].name;

              // convert name to string that can be used by .data() function
              optionTypes.forEach((selectElem) => {
                if (selectElem.name !== optionType) {
                  optionNames.push(selectElem.name);
                  let convert = selectElem.name
                    .replace('-', ' ')
                    .replace(/(?:\s)\S/g, (a) => a.toUpperCase());
                  convert = convert.replace(' ', '');
                  selectNames.push(convert);
                }
              });

              document.querySelectorAll('.vars-value div').forEach((div) => {
                if (div.dataset[optionType] === optionValue) {
                  selectNames.forEach((name, i) => {
                    if (i === 0) {
                      options2.push(div.dataset[name]);
                    } else if (i === 1) {
                      options3.push(div.dataset[name]);
                    }
                  });
                }
              });

              // only trigger the disabling/enabling of options on first dropdown change
              if (optionType === option1) {
                let atcButton = this.closest(
                  '.cpap__product-comparisons__add-to-cart-button'
                ).querySelector('button');

                // disable button to prevent adding to cart
                if (!atcButton.disabled) {
                  atcButton.disabled = true;
                }

                // loop through each select and option tags to disable/enable options
                optionTypes.forEach((selectElem, index) => {
                  const selectName = selectElem.getAttribute('name'); // Get the name attribute of the select element

                  Array.from(selectElem.children).forEach((option) => {
                    for (let i = 0; i < optionNames.length; i++) {
                      if (selectName === optionNames[i]) {
                        option.setAttribute('disabled', 'true'); // Disable all options by default

                        if (i === 0) {
                          for (let j = 0; j < options2.length; j++) {
                            if (option.value === options2[j]) {
                              option.removeAttribute('disabled');
                            }
                          }
                        } else if (i === 1) {
                          for (let j = 0; j < options3.length; j++) {
                            if (option.value === options3[j]) {
                              option.removeAttribute('disabled');
                            }
                          }
                        }
                      }
                    }
                  });
                });
              }
            });
          });
        }
      });

      toggleHeaderLogoOrientation();
      document.querySelector('.cpap__page-loader--on-page-load')?.classList.add('d-none');

      const debouncedtoggleHeaderLogoOrientation = window.cpap.debounce(() => {
        toggleHeaderLogoOrientation();

        const progressSpan = document.getElementById('quiz-progress');
        const currentProgress = parseInt(progressSpan.textContent, 10);
        updateProgressBar(currentProgress);
      }, 250);

      window.addEventListener('resize', debouncedtoggleHeaderLogoOrientation, { passive: true });

      document.getElementById('btn-quiz').addEventListener('click', function () {
        loadDeferredUtilityFunctions(() => {
          window.cpap.visualEffects.fadeOut('.start-quiz-main');

          setTimeout(() => {
            const quizSteps = document.querySelector('.quiz-steps');
            window.cpap.visualEffects.fadeIn(quizSteps);
            quizSteps.style.setProperty('display', 'flex', 'important');
            document.getElementById('tabbing-prev')?.classList?.add('cpap__fadeable--hidden');
          }, 500);
        });
      });

      let stepCount = document.querySelectorAll('.tabbing-content[data-type="question"]').length;

      if (stepCount >= 1) {
        let quizBannerText = 'Answer these ' + stepCount + ' short questions to see the results';
        document.querySelector('.start-quiz-content h3').textContent = quizBannerText;
      } else {
        let quizBannerText = 'To Be Determined';
        document.querySelector('.start-quiz-content h3').textContent = quizBannerText;
      }

      document.querySelectorAll('.tabbing-main .tabbing-content').forEach((element, index) => {
        if (index !== 0) element.classList.add('cpap__fadeable--hidden');
      });

      document.getElementById('tabbing-prev')?.addEventListener('click', function () {
        let current = window.cpap.getFirstVisibleElement('.tabbing-main .tabbing-content');

        let prev = current ? current.previousElementSibling : null;

        if (prev.classList.contains('first-question')) {
          document.getElementById('tabbing-next')?.classList?.remove('cpap__fadeable--hidden');
          document.getElementById('tabbing-prev')?.classList?.add('cpap__fadeable--hidden');
        } else if (prev.classList.contains('last-question')) {
          document.getElementById('tabbing-next')?.classList?.remove('cpap__fadeable--hidden');
        }

        if (prev.dataset.type.startsWith('result')) {
          document.getElementById('view-cart')?.remove();
          document.getElementById('view-checkout')?.remove();
          document.getElementById('tabbing-prev')?.classList?.add('cpap__fadeable--hidden');
          document.getElementById('tabbing-continue')?.classList?.remove('cpap__fadeable--hidden');
        } else {
          document.getElementById('view-cart')?.remove();
          document.getElementById('view-checkout')?.remove();
          document.getElementById('tabbing-continue')?.classList?.add('cpap__fadeable--hidden');
        }

        if (prev) {
          loadDeferredUtilityFunctions(() => {
            window.cpap.visualEffects.fadeOut(current);

            setTimeout(function () {
              window.cpap.visualEffects.fadeIn(prev);

              if (prev.dataset.type === 'form') {
                window.cpap.visualEffects.fadeOut(prev);
                window.cpap.visualEffects.fadeIn(prev);
                setTimeout(() => {
                  document
                    .querySelector('.header__icon--cart svg path')
                    .setAttribute('fill', '#2e2e2e');
                }, 500);
                window.cpap.visualEffects.fadeOut('.header-caret-icon');
              } else {
                window.cpap.visualEffects.fadeIn('.header-caret-icon');
              }
            }, 250);
          });
        }

        if (!document.querySelector('.error-msg')?.classList?.contains('hidden')) {
          document.querySelector('.error-msg').classList.add('hidden');
        }

        calculateProgress();
      });

      document.getElementById('tabbing-next').addEventListener('click', handleNextClick);
      document.getElementById('tabbing-continue').addEventListener('click', handleNextClick);

      function handleNextClick() {
        let current = window.cpap.getFirstVisibleElement('.tabbing-main .tabbing-content');
        let type = current.getAttribute('data-type');
        let validate = type === 'question';
        let next = current.nextElementSibling;
        let nextType = next?.getAttribute('data-type');
        let nextSiblingDataType = next?.nextElementSibling?.getAttribute('data-type');
        let isProductForm = nextType === 'form';

        const getIsFinalProductResultSet = () => {
          const dataTypeToCheck =
            next?.nextElementSibling?.getAttribute('data-type') || next?.getAttribute('data-type');
          const resultSetsToCheck = document.querySelectorAll('[data-type^="result"]');

          if (dataTypeToCheck === 'result' && resultSetsToCheck.length === 1) {
            return true;
          }

          return (
            dataTypeToCheck.startsWith('result') &&
            resultSetsToCheck.length === parseInt(dataTypeToCheck.replace('result', '') || '1', 10)
          );
        };

        loadDeferredUtilityFunctions(async () => {
          if (next && !validate) {
            window.cpap.visualEffects.fadeOut(current);

            setTimeout(() => {
              window.cpap.visualEffects.fadeIn(next);
            }, 250);
          } else if (next && validate) {
            let activetab = current.querySelectorAll('.choose-block.active').length;
            let isNonLastProductResultSet =
              nextSiblingDataType.startsWith('result') && !getIsFinalProductResultSet();
            if (activetab) {
              document.getElementById('tabbing-prev')?.classList?.remove('cpap__fadeable--hidden');

              window.cpap.visualEffects.fadeOut(current);

              setTimeout(() => {
                window.cpap.visualEffects.fadeIn(next);
              }, 250);

              if (isProductForm || isNonLastProductResultSet) {
                window.cpap.visualEffects.fadeOut('.header-caret-icon');
                document.getElementById('tabbing-next')?.classList?.add('cpap__fadeable--hidden');
                document.getElementById('subscription-submission').click();
                document.getElementById('tabbing-prev')?.classList?.add('cpap__fadeable--hidden');
              }
            } else {
              document.querySelector('.error-msg')?.classList?.remove('hidden');
            }
          }

          // Await 10ms for result sets to appear.
          await new Promise((resolve) => setTimeout(resolve, 10));

          if (getIsFinalProductResultSet()) {
            setTimeout(() => {
              document
                .querySelector('.header__icon--cart svg path')
                .setAttribute('fill', 'var(--cpap-primary-white');
            }, 750);

            document.getElementById('tabbing-continue')?.classList?.add('cpap__fadeable--hidden');

            // Check and remove existing buttons if they already exist
            addCartButtons();
          }

          calculateProgress();
        });
      }

      document
        .querySelector('.tabbing-content[data-type="form"] .btn-submit')
        .addEventListener('click', function (e) {
          e.preventDefault();
          calculateQuizResult();
          calculateProgress();
        });

      document.querySelectorAll('.choose-block').forEach((block) => {
        block.addEventListener('click', function () {
          this.closest('.choose-block-main')
            .querySelectorAll('.choose-block')
            .forEach((b) => b.classList.remove('active'));
          this.classList.add('active');
          document.getElementById('tabbing-next').click();
          if (window.cpap.isElementVisible('.error-msg')) {
            document.querySelector('.error-msg').classList.add('hidden');
          }
        });
      });

      function calculateQuizResult() {
        loadDeferredUtilityFunctions(() => {
          setTimeout(() => {
            document
              .querySelector('.header__icon--cart svg path')
              .setAttribute('fill', 'var(--cpap-primary-white');
            window.cpap.visualEffects.fadeIn('.header-caret-icon');
          }, 1000);

          document
            .querySelectorAll('.tabbing-content')
            .forEach((content) => content.classList.add('cpap__fadeable--hidden'));

          setTimeout(() => {
            window.cpap.visualEffects.fadeIn('.tabbing-content[data-type="result"]');

            let current = window.cpap.getFirstVisibleElement('.tabbing-main .tabbing-content');

            let next = current.nextElementSibling;

            if (next) {
              document
                .getElementById('tabbing-continue')
                .classList.remove('cpap__fadeable--hidden');
            } else {
              document.getElementById('tabbing-continue').classList.add('cpap__fadeable--hidden');

              addCartButtons();
            }
          }, 250);
        });
      }

      function calculateProgress() {
        setTimeout(() => {
          let current = window.cpap.getFirstVisibleElement('.tabbing-main .tabbing-content');

          let tabs = document.querySelectorAll(
            '.tabbing-main .tabbing-content[data-type="question"], .tabbing-main .tabbing-content[data-type="form"]'
          );
          let totalTabs = tabs.length;
          let currentIndex = Array.from(tabs).indexOf(current);
          let progressPercentage;

          if (totalTabs === 0) {
            progressPercentage = 0;
          } else {
            if (progressPercentage >= 100 || current.dataset.type.startsWith('result')) {
              progressPercentage = 100;
            } else {
              progressPercentage = Math.ceil((currentIndex / totalTabs) * 100);
            }
          }

          updateProgressBar(progressPercentage);
        }, 500);
      }

      function updateProgressBar(progress) {
        const siteLogo = document.querySelector('.site-logo');
        const progressSpan = document.getElementById('quiz-progress');
        const containerWidth = document.querySelector('.page-width').offsetWidth;

        // 20% width represents 0% progress, leaving 80% width as 0-100% progress range
        let newWidth = containerWidth * (0.2 + 0.8 * (progress / 100));

        if (window.innerWidth <= 690) {
          if (newWidth < 127) {
            newWidth = 127;
          } else {
            newWidth *= 0.9;
          }
        }

        loadDeferredUtilityFunctions(() => {
          if (progress >= 100) {
            window.cpap.visualEffects.fadeOut(progressSpan);
          } else {
            window.cpap.visualEffects.fadeIn(progressSpan);
          }
        });

        // Apply new width
        siteLogo.style.width = newWidth + 'px';
        progressSpan.textContent = progress + '%';
      }

      function toggleHeaderLogoOrientation() {
        let windowWidth = window.innerWidth;
        let headerLogoSvg = document.getElementById('quiz-header-logo');
        let parentElement = headerLogoSvg.parentElement;
        //Background divs might make more sense irrespective of SEO benefit - will discuss with Jason and refactor this
        if (windowWidth <= 1300) {
          parentElement.insertAdjacentHTML(
            'beforeend',
            `<img src="${window.cpap.multipleProductQuiz.mobileHeaderLogo}" id="quiz-header-logo">`
          );
          headerLogoSvg.remove();
        } else {
          parentElement.insertAdjacentHTML(
            'beforeend',
            `<img src="${window.cpap.multipleProductQuiz.desktopHeaderLogo}" id="quiz-header-logo">`
          );
          headerLogoSvg.remove();
        }
      }
    },
    { priority: 'user-blocking' }
  );
});
